Vue.config.devtools = process.env.NODE_ENV === 'development' ? true : false;
import Vue from "vue";
import App from "./App.vue";
// import router from "./router/index";
import router from "./router";
import store from "./store/index.js";
import "@/assets/css/common.css";
import common from "./utils/common.js";
Vue.prototype.common = common;

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
import '@/permission' // permission control
import {
    Button,
    Container,
    Header,
    Main,
    Aside,
    Footer,
    Divider,
    Input,
    Icon,
    Carousel,
    CarouselItem,
    Checkbox,
    CheckboxGroup,
    Card,
    Col,
    Menu,
    MenuItem,
    Breadcrumb,
    BreadcrumbItem,
    Rate,
    Submenu,
    Avatar,
    Tag,
    Tabs,
    TabPane,
    Form,
    FormItem,
    Radio,
    RadioGroup,
    Select,
    Option,
    Row,
    Dialog,
    Upload,
    Pagination,
    Tree,
    Message,
    MessageBox,
    Collapse,
    CollapseItem,
    Switch,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DatePicker,
    Tooltip,
    Progress,
    Image,
    Autocomplete,
    RadioButton,
    Badge,
    ButtonGroup,
    Table,
    TableColumn,
    Step,
    Steps,
} from "element-ui";

Vue.config.productionTip = false;

Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Aside);
Vue.use(Footer);
Vue.use(Divider);
Vue.use(Input);
Vue.use(Icon);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Rate);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Submenu);
Vue.use(Avatar);
Vue.use(Card);
Vue.use(Col);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(Select);
Vue.use(Option);
Vue.use(Row);
Vue.use(Dialog);
Vue.use(Upload);
Vue.use(Pagination);
Vue.use(Tree);
Vue.use(Image);
Vue.use(Autocomplete);
Vue.use(Badge);
Vue.use(ButtonGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Switch);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(DatePicker);
Vue.use(Tooltip);
Vue.use(Progress);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Step);
Vue.use(Steps);
Vue.component(Message);
Vue.component(MessageBox);
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
window.callLogout = function () {
    store.dispatch('user/logout')
}
import configStore from '@/store/configStore'

router.beforeEach(async(to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.meta.description) {
        document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description)
    }
    if (to.meta.keywords) {
        document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords)
    }
    let head = document.getElementsByTagName('head');
    if (!configStore.getters.baseUrl || !configStore.getters.baseUrl.OPEN_BASE_URL) {
        await configStore.dispatch('init');
    }

    if (!configStore.getters.baseUrl || !configStore.getters.baseUrl.OPEN_BASE_URL) {
        // next('/404');
        // return;
    }
    if (to.meta.requireAuth) {
        // setTimeout(() => {
        //     var _hmt = _hmt || [];
        //     (function () {
        //         //每次执行前，先移除上次插入的代码
        //         document.getElementById('is_login') && document.getElementById('is_login').remove();
        //         var hm = document.createElement("script");
        //         hm.type = "text/javascript"
        //         hm.src = configStore.getters.baseUrl.UC_BASE_URL + "/api/User/checklogin";
        //         hm.id = "is_login"
        //         var s = document.getElementsByTagName("script")[0];
        //         s.parentNode.insertBefore(hm, s);
        //     })();
        // }, 0);
    }
    next();
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");